import React, { Component } from 'react'
import { connect } from 'react-redux'

import General from '../components/TiquetesAereos/General'
import Cotizacion from '../components/TiquetesAereos/Cotizacion'
import Aprobaciones from '../components/TiquetesAereos/Aprobaciones'
import Tiquetes from '../components/TiquetesAereos/Tiquetes'
import Asistencia from '../components/TiquetesAereos/Asistencia'
import Cierre from '../components/TiquetesAereos/Cierre'
import Cancelacion from '../components/TiquetesAereos/Cancelacion'


import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'



import { 
    canmbiarResponsable,
    showModalConfirmarAccion
} from '../actions/common'



import { 
    getSolicitud,
    displayModalSelectVersion,
    updateTravel,
    updateTiquetesAereo, 
    registerTiquetes, 
    registerAsistencias, 
    registerTiquetesExpirados, 
    descargarAsistencia,
    registerCancelacion
} from '../actions/tiquetesaereo'

import history from '../utils/history'

import { isAllowedToViewComponent } from '../utils/helpers'




class TiquetesAereo extends Component {

	constructor(props) {
		super(props)
		this.state = {
			tabs: [
                { id: 0, caption: 'Solicitud', component: <General/>, estado: 1 },
                { id: 1, caption: 'Cotización', component: <Cotizacion/>, estado: 2 },
                { id: 2, caption: 'Aprobación', component: <Aprobaciones selectedTab={this.selectTab.bind(this)} />, estado: 3 },
                { id: 3, caption: 'Tiquetes', component: <Tiquetes/>, estado: 4 },
                { id: 4, caption: 'Asistencia', component: <Asistencia/>, estado: 4 },
                { id: 5, caption: 'Cierre', component: <Cierre/>, estado: 6 },
                { id: 6, caption: 'Cancelacion', component: <Cancelacion/>, estado: 0 },
			],
			selected: 0
		}
    }

    componentWillMount() {
        if (this.props.match.params.id) {
            this.props.getSolicitud(this.props.match.params.id)
            const params = new URLSearchParams(this.props.location.search);
            if (params.has("aprobacion")) {
                this.setState({selected: 2})
            }
        } else {
            history.push(window.FOLDER + '/solicitudes/nuevas')
        }
    }

	selectTab = (e, tab) => {
		e.preventDefault()
		this.setState({ selected: tab })
    }
    
    cancel = () => {
        this.props.showModalConfirmarAccion(true, `¿Está seguro que desea cancelar la solicitud?`, () => { this.props.showModalConfirmarAccion(false); this.props.registerCancelacion()})
    }

	render() {

		const { tabs, selected } = this.state
        const { estado, asistencia, pasajeros_actualizados, solicitud, btnRComprasDisabled } = this.props

        const descargar_asistencia = pasajeros_actualizados ? 
            pasajeros_actualizados.filter(a => a.getIn(['asistencia', 'fecha_compra']) == null).count() == 0 : false

        let boxActions; 
        
        const readOnly = !isAllowedToViewComponent('responsable_compras', solicitud) 
        const onlySolicitante = isAllowedToViewComponent('solicitante', solicitud) 

        boxActions = [
            <BoxButton key="ba[0][0]" name="pencil" onClick={ () => this.props.updateTravel() } title="Editar información viaje" disabled={ estado > 3 || estado == 0 || selected !== 0 || readOnly } />,
            <BoxButton key="ba[0][1]" name="history" onClick={ () => this.props.displayModalSelectVersion(true, "Listado de versiones") } title="Seleccionar versión" disabled={ estado > 3 || estado == 0 || selected !== 0 || readOnly } />,
            <BoxButton key="ba[0][2]" name="floppy-o" onClick={ () => this.props.updateTiquetesAereo() } title="Enviar a aprobación" disabled={ estado !== 2 || selected !== 1 || readOnly } />,
            <BoxButton key="ba[0][3]" name="user" onClick={ () => this.props.canmbiarResponsable(solicitud, 'ACTUALIZAR_SOLICITUD_TIQUETESAEREO') } title="Cambiar responsable" disabled={ btnRComprasDisabled || selected !== 0 || readOnly } />,
            <BoxButton key="ba[0][4]" name="ticket" onClick={ () => this.props.registerTiquetes() } title="Registrar tiquetes" disabled={ estado !== 4 || selected !== 3 || readOnly } />,
            <BoxButton key="ba[0][5]" name="plane" onClick={ () => this.props.registerAsistencias() } title="Registrar asistencia al viajero" disabled={ (estado < 4 || estado > 6) || selected !== 4 || descargar_asistencia || readOnly } />,
            <BoxButton key="ba[0][6]" name="cloud-download" onClick={ () => this.props.descargarAsistencia() } title="Descargar asistencia al viajero" disabled={ !descargar_asistencia || selected !== 4 || readOnly } />,
            <BoxButton key="ba[0][7]" name="check" onClick={ () => this.props.registerTiquetesExpirados() } title="Actualizar información" disabled={ (estado !== 6 || selected !== 5 || !onlySolicitante) } />,
            <BoxButton key="ba[0][8]" name="ban" onClick={ () => this.cancel() } title="Aprobar cancelación solicitud" disabled={ readOnly || selected !== 6 || estado == 0 } />
        ]

        if (!descargar_asistencia) {
            boxActions.splice(6, 1)
        }

        
		return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <div className="nav-container">
                        <div className="nav-tabs-section">
                            <ul className="nav-tabs-tabs">
                                {
                                    tabs.filter(x => x.estado <= estado || estado == 0).map(x => {

                                        if (estado == 0 && x.estado == 4) return null
                                        if (estado == 0 && x.estado == 5) return null
                                        if (estado == 0 && x.estado == 6) return null
                                        if (!asistencia && x.id == 4) return null

                                        return (
                                            <li key={ `li01[${x.id}]` } className={ selected === x.id ? 'active' : '' }>
                                                <a onClick={ (e) => this.selectTab(e, x.id) }>{ x.caption }</a>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                        <div className="nav-main-section">
                            <div className="">
                                <ButtonStrip actions={ boxActions } />
                            </div>
                            <div className="nav-main-section-scrollable">
                                { tabs[selected].component }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        btnSaveDisabled: state.tiquetesaereo.get('btnSaveDisabled'),
        estado: state.tiquetesaereo.get('estado'),
        asistencia: state.tiquetesaereo.getIn(['solicitud', 'viaje', 'asistencia_viajero']),
        pasajeros_actualizados: state.tiquetesaereo.getIn(['unchaged', 'viaje', 'pasajeros']),
        btnRComprasDisabled: state.tiquetesaereo.get('btnRComprasDisabled'),
        solicitud: state.tiquetesaereo.get('solicitud'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getSolicitud: (id) => dispatch(getSolicitud(id)),
        updateTiquetesAereo: () => dispatch(updateTiquetesAereo()),
        updateTravel: () => dispatch(updateTravel()),
        registerTiquetes: () => dispatch(registerTiquetes()),
        registerAsistencias: () => dispatch(registerAsistencias()),
        registerTiquetesExpirados: () => dispatch(registerTiquetesExpirados()),
        descargarAsistencia: () => dispatch(descargarAsistencia()),
        canmbiarResponsable: (solicitud, type) => dispatch(canmbiarResponsable(solicitud, type)),
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        displayModalSelectVersion: (show, message, action) => dispatch(displayModalSelectVersion(show, message, action)),
        registerCancelacion: () => dispatch(registerCancelacion()),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(TiquetesAereo)


// WEBPACK FOOTER //
// ./src/containers/TiquetesAereos.jsx